export default __webpack_public_path__ + "static/media/cover-1.9cd85005.webp";